import React from "react";
import { Loader2 } from "lucide-react";
import "./RouteLoader.css";

interface RouteLoaderProps {
  variant?: "inline" | "minimal";
  message?: string;
  showGradient?: boolean;
}

export const RouteLoader: React.FC<RouteLoaderProps> = ({
  variant = "inline",
  message = "Loading...",
  showGradient = true,
}) => {
  // Inline: Center 3-ring spinner in route container with optional gradient
  if (variant === "inline") {
    return (
      <div
        className={`route-loader-inline ${showGradient ? "with-gradient" : ""}`}
      >
        <div className="loader-content">
          {/* 3-ring spinner (same as LoadingScreen) */}
          <div className="loading-spinner">
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
          </div>

          {/* Loading Message */}
          <div className="loader-message">{message}</div>

          {/* Animated Dots */}
          <div className="loading-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    );
  }

  // Minimal: Small spinner for breadcrumb area
  return (
    <div className="flex items-center gap-2">
      <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
      <span className="text-sm text-muted-foreground">{message}</span>
    </div>
  );
};
